import { useCallback, useMemo } from "react";

import { Step } from "@is/types";

type Props = {
  steps: Step[];
  onStepChange?: (stepIndex: number) => void;
};

const useManageStepper = ({ onStepChange, steps }: Props) => {
  const handleStepClick = useCallback(
    (stepIndex: number) => () => {
      if (onStepChange) {
        onStepChange(stepIndex);
      }
    },
    [onStepChange]
  );

  const hasLabels = useMemo(() => steps.some((step) => step?.label), [steps]);

  return {
    handleStepClick,
    hasLabels,
  };
};

export default useManageStepper;
